import { render, staticRenderFns } from "./Receivers.vue?vue&type=template&id=4bd4695c&"
import script from "./Receivers.vue?vue&type=script&lang=js&"
export * from "./Receivers.vue?vue&type=script&lang=js&"
import style0 from "./Receivers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports